import { Component, HostBinding, Input, OnInit } from '@angular/core';

import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { PhosphorIconComponent } from '@cintra-payroll-hr/components';
import { Member, MyEmploymentModel } from '@security/users/models/member';
import { DateTime } from 'luxon';
import { BodyComponent } from '@design/typography/body/body.component';
import { BodyExtraSmallComponent } from '@design/typography/body-xs/body-extra-small.component';
import { BodyMediumComponent } from '@design/typography/body-md/body-medium.component';
import { TestIdDirective } from '@design/core/test-id.directive';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthStorageService } from '@auth-n/state/auth-storage.service';

interface OrganisationEmploymentModel {
  organisationName: string;
  myEmploymentModel: MyEmploymentModel;
}

/**
 * Material menu which presents the list of Employments the user can select to work with.
 * Embedded in the {@link HeaderComponent}.
 */
@UntilDestroy()
@Component({
  selector: 'app-employment-menu',
  templateUrl: './employment-menu.component.html',
  styleUrls: ['../_context-menu.scss', 'employment-menu.component.scss'],
  standalone: true,
  imports: [
    MatMenuModule,
    MatButtonModule,
    PhosphorIconComponent,
    BodyComponent,
    BodyExtraSmallComponent,
    BodyMediumComponent,
    TestIdDirective
  ]
})
export class EmploymentMenuComponent implements OnInit {
  employments: OrganisationEmploymentModel[] = [];
  @Input() activeMembership!: Member;
  @Input() activeEmployment!: MyEmploymentModel;
  @Input() memberships!: Member[];

  constructor(private authStorageService: AuthStorageService) {}

  ngOnInit(): void {
    this.employmentsToList();
  }

  private employmentsToList() {
    const list: OrganisationEmploymentModel[] = [];
    this.memberships.forEach((m) => {
      m.employments.forEach((model) => {
        if (model.accountExpired) return;
        list.push({
          organisationName: m.organisationName,
          myEmploymentModel: model
        });
      });
    });
    this.employments = list;
  }

  getEmploymentPeriod = (employment: MyEmploymentModel) => {
    const fromDate = DateTime.fromISO(employment.fromDate).toFormat('dd MMM yyyy');
    const toDate = employment.toDate ? DateTime.fromISO(employment.toDate).toFormat('dd MMM yyyy') : 'now';
    return `${fromDate} - ${toDate}`;
  };

  select = (employment: OrganisationEmploymentModel) => this.authStorageService.setActiveEmployment(employment.myEmploymentModel);
}
